// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__24FCb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3HsXg"};